// src/AuthCallback.js
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { msalInstance, ensureMsalInitialized } from "./auth/msalInstance";
import { useAuth } from "context/AuthContext";
import { apiRequest } from "./auth/msalConfig"; 
import { closeSnackbar } from "store/slices/snackbar";
import { API_END_POINT } from "config";


export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const { getuserInfo } = useAuth();
  const dispatch = useDispatch();
  let notificationTimeout;

  useEffect(() => {
    (async () => {
      try {
        // Process the redirect response (this sets account in cache)
        await ensureMsalInitialized();
        const result = await msalInstance.handleRedirectPromise();
        // Pick an account (prefer the one from result, else first cached)
        const acct = result?.account ?? msalInstance.getAllAccounts()[0];
        if (!acct) {
          // not signed in – send to /login or show an error
          navigate("/login", { replace: true });
          return;
        }

        // Make it active for the session
        msalInstance.setActiveAccount(acct);

        // Get an access token for your API scope
        const tokenResp = await msalInstance.acquireTokenSilent({
          ...apiRequest,           // { scopes: ["api://<app-id>/user.read"] }
          account: acct
        });

        // Persist for your existing app flow
        localStorage.setItem("token", tokenResp.accessToken);
        localStorage.setItem("user", JSON.stringify({ userName: acct.username }));

        const probeResp = await fetch(`${API_END_POINT}account/user/info`, {
          headers: {
            Authorization: `Bearer ${tokenResp.accessToken}`,
          },
        });
        if (!probeResp.ok) {
          // Try to read structured error from backend
          let message = "Sign-in succeeded, but we couldn't load your account.";
          let code = null;

          try {
            const data = await probeResp.json();
            code = data?.code;
            if (probeResp.status === 401 && code === "UserNotProvisioned") {
              message =
                "Your account is not yet provisioned for this application. Please contact your administrator.";
            } else if (probeResp.status === 401) {
              message = "You are not authorized to use this application.";
            } else if (probeResp.status === 403) {
              message = "You don't have permission to access this application.";
            }
          } catch {
            // ignore JSON errors, keep default message
          }

          setError(message);
          return; // ⛔ Do NOT call getuserInfo
        }
        getuserInfo(tokenResp.accessToken);

        //clearTimeout(notificationTimeout);
        dispatch(closeSnackbar());
        navigate("/", { replace: true });

      } catch (err) {
        console.error("MSAL redirect error:", err);
        setError(err?.message || "Authentication failed");
      }
    })();
  }, [navigate]);

  if (error) {
    return (
      <div style={{ padding: 16 }}>
        <h3>Sign-in failed</h3>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div style={{ padding: 16 }}>
      <h3>Signing you in…</h3>
      <p>Please wait — finishing authentication.</p>
    </div>
  );
}
